export const experiences = [
	{  
		role: 'Frontend Developer',
		company: 'Scelloo - Cloudenly',
		startEnd: 'March 2024 - Present',
		workType: 'Remote',
		descriptions: [
			'Build and maintain responsive UIs from design specifications using Vue.',
			'Collaborate with backend engineers to integrate APIs and improve data flow across applications.',
			'Contribute to internal  frontend walkthroughs and collaborative development discussions.',
			'Debug and test frontend code to resolve the issues, ensuring stable releases.',
			'Participate in code reviews and knowledge sharing (PR reviews, mini walkthroughs), raising code quality and team consistency.',
		],
		id: 0,
	},
	{
		role: 'Frontend Developer',
		company: 'AyaHQ (Techstars ‘23) Hackathon',
		startEnd: 'March 2024',
		workType: 'Remote',
		descriptions: [
			'Sole frontend developer for Xenrena, a game platform redefining decentralized prediction play.',
			'Collaborated with three team members (a backend/blockchain developer, a product manager and a designer) to deliver a fully functional prototype within the hackathon timeframe.',
			'The Xenrena project secured 3rd place among all participating teams.',
		],
		id: 1,
	},
	{
		role: 'Frontend Developer(Web3)',
		company: 'Xeggo',
		startEnd: 'November 2021 - July 2022',
		workType: 'Remote',
		descriptions: [
			'User Interface Design: Built, implemented, and maintained many user interfaces according to design specifications using React and modern JavaScript.',
			'Integration of smart contracts via Ethers.js and Web3.js, with wallet connections handled for seamless Web3 interactions.',
			'Interacted with the blockchain to read/write data and sign transactions. ',
			'Tested, debugged frontend code to identify and fix issues.',
		],
		id: 2,
	},
	{
		role: 'Internship',
		company: 'Spurbuddy',
		startEnd: 'May - June 2020',
		workType: 'Remote',
		descriptions: [
			'Conversion of UI designs to code using React and Making AJAX calls.',
			'Styled and make the web to be responsive depending on the user’s device screen size using plain CSS.',
		],
		id: 3,
	},
	{
		role: 'Internship',
		company: 'Google Africa Developers Scholarship',
		startEnd: 'May 2019',
		workType: 'Remote',
		descriptions: [
			'Learned the fundamentals of web development',
			'Learned Programming fundamentals.',
			'Learned new more technologies.',
			'Used what I learned to build up some projects.',
		],
		id: 4,
	},
];
